// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".Contact{position:relative;background-color:rgba(0,0,0,0.05);min-height:600px}.Contact .backgroundGradient{background-image:linear-gradient(-225deg, #2e4384, #fff 65%, #fff);position:absolute;top:0;right:0;left:0;bottom:20%}.Contact .ContactForm{max-width:400px;width:100%}.Contact img{max-width:80%}\n", ""]);
// Exports
module.exports = exports;
